"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preview = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Preview = styled_components_1.default.p `
  color: #565961;
`;
